<template>


    <div class="page-content">   
		<div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
		<div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
		<div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>
		
		<div class="page-title-small color-white bottom-30">
			<h1><i class="fa fa-arrow-left back-button"></i>Cambio de fecha de entrega OT {{ idcotizacionvehiculo }}</h1>
			<a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark" v-bind:style="userimageurl"></a>
		</div>
	
     
		<div class="content-boxed">


  			<div class="content bottom-0">
				
				<div data-height="215" class="caption caption-margins round-medium shadow-large">
					<div class="caption-bottom left-20 bottom-15">
						<p class="bottom-0 color-white opacity-50 under-heading font-12">{{ fecha }}, {{ sucursal }}</p>
						<h1 class="color-white bottom-0 bolder">{{ OT.marca }}</h1>
						<h1 class="color-white bottom-0 bolder">{{ OT.modelo }}</h1>
						<h1 class="color-white bottom-0 bolder">{{ OT.version }}</h1>
						<h1 class="color-white bottom-0 bolder">{{ OT.agno }}</h1>
						<p class="bottom-0 color-white opacity-50 under-heading font-12">{{ OT.vin }}</p>
						<h1 class="color-white bottom-0 bolder">{{ OT.placapatente }}</h1>
					</div>
					<div class="caption-overlay bg-black opacity-75"></div>
					<div class="caption-bg bg-29"></div>
				</div>   

				<form onsubmit="event.preventDefault();" style="display:none" class="contactForm" id="Formsubmitvehiculo">
					<input id="codvehiculo" name="field_IN_KILOMETRAJE_VEHICULO" v-model="OT.kilometraje">
					<input id="codvehiculo" v-model="OT.codvehiculo">
				</form>

                <div class="contact-form">
                    <form onsubmit="event.preventDefault();" class="contactForm" id="Formsubmit">
                        <fieldset>

							<input type="hidden" id="fechaentregaot" name="field_DT_FECHAENTREGAOT_COTIZACIONVEHICULO" v-model="OT.fechaentregaot">

							<div >

								<span id="r_fechaentrega" name="r_fechaentrega" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Fecha de entrega requerida</span>
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Fecha entrega:<span>(requerida)</span></label>
									<input id="fechaentrega" name="fechaentrega" type="date"
									v-model="OT.fechaentrega" 
									class="round-small">
								</div>

								<span id="r_horaentrega" name="r_horaentrega" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Hora de entrega requerida</span>
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Hora entrega:<span>(requerido)</span></label>
									<input id="horaentrega" type="time" name="horaentrega"
									v-model="OT.horaentrega" 
									class="round-small">
								</div>


                            </div>

                        </fieldset>


						<div class="content-boxed">
							<a href="#" data-menu="menu-email" class="icon icon-xs icon-circle bg-blue2-dark" style="height:70px;width:70px"><i data-feather="mail" data-feather-line="1" data-feather-size="40"></i><span class="color-blue2-dark" style="position:relative;top:-20px">Mail</span></a>
							&nbsp;
							<a href="#" data-menu="menu-whatsapp" class="icon icon-xs icon-circle bg-green2-dark" style="height:70px;width:70px"><i data-feather="message-circle" data-feather-line="1" data-feather-size="50"></i><span class="color-green2-dark" style="position:relative;top:-20px">Whatsapp</span></a>
						</div>

                    </form>			
                </div>
            </div>

 


    	</div>
		





			


			<div id="sendingmail" class="shadow-large alert alert-large alert-round-medium bg-green1-dark" style="display:none">
                <i class="fa fa-check"></i>
                <strong class="uppercase ultrabold">Success</strong>
                <span>Everything's okay here</span>
                <i class="fa fa-times"></i>
            </div>  

			<div id="menu-email" class="menu menu-box-bottom menu-box-detached round-medium" data-menu-height="290" data-menu-effect="menu-over">
					<div id="menu-emailcontent" class="content">
						<h1 class="uppercase ultrabold top-20">Envío de OT por Email</h1>
						<form id="formemail">
							<span id="r_txtemail" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Requerido</span>
							<span id="e_txtemail" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">El formato de e-mail es incorrecto</span>
							<div class="input-style has-icon input-style-1 input-required">
								<span>Email</span>
								<em>(requerido)</em>
								<input id="txtemail" type="email" placeholder="Email" v-model="OT.email">
							</div>
			
							<div class="clear"></div>
							<a href="#" @click="enviarmail" class="button button-full button-s shadow-large button-round-small bg-blue2-dark top-10">Enviar e-mail</a>
							<div class="top-20 bottom-20">
								<a href="#" data-menu="salir" class="center-text font-11 color-gray2-dark">Para cancelar presione aquí</a>
							</div>
						</form>

					</div>

					<div id="sendingmail" class="shadow-large alert alert-large alert-round-medium bg-green1-dark" style="display:none">
						<i class="fa fa-check"></i>
						<strong class="uppercase ultrabold">Success</strong>
						<span>Everything's okay here</span>
						<i data-menu="salir" class="fa fa-times"></i>
					</div>  

			</div> 

			<div id="menu-whatsapp" class="menu menu-box-bottom menu-box-detached round-medium" data-menu-height="290" data-menu-effect="menu-over">
					<div class="content">
						<h1 class="uppercase ultrabold top-20">Envío de OT por Whatsapp</h1>
						<form id="formwhatsapp">
							<span id="r_txtfonowhatsapp" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Requerido</span>
							<div class="input-style has-icon input-style-1 input-required">
								<span>Teléfono</span>
								<em>(requerido)</em>
								<input id="txtfonowhatsapp" type="text" maxlength="11" placeholder="Teléfono" v-model="OT.fonowhatsapp">
							</div>
			
							<div class="clear"></div>
							<a href="#" @click="enviarwhatsapp" class="button button-full button-s shadow-large button-round-small bg-green2-dark top-10">Enviar Whatsapp</a>
							<div class="top-20 bottom-20">
								<a href="#" data-menu="salir" class="center-text font-11 color-gray2-dark">Para cancelar presione aquí</a>
							</div>

						</form>

					</div>

					<div id="sendingmail" class="shadow-large alert alert-large alert-round-medium bg-green1-dark" style="display:none">
						<i class="fa fa-check"></i>
						<strong class="uppercase ultrabold">Success</strong>
						<span>Everything's okay here</span>
						<i data-menu="salir" class="fa fa-times"></i>
					</div>  

			</div> 
   




		
    </div>



</template>

<script>

import * as db from "../../database.js";
import * as validate from "../../validate.js";

export default {
	data() {
      return {
		  params:'{"valkey":"'+localStorage.getItem('idcotizacionvehiculo')+'","tablename":"T_VEH_COTIZACIONVEHICULO"}',
		  idcotizacionvehiculo:0,
		  codusuario:0,
		  fecha:"",
		  sucursal:"" ,
		  idagenda:0,
		  idFile:Math.floor(Math.random() * 10000),
		  Direccioncliente:{},
		  OT:{}
	  }		
	},

	created(){
		this.idcotizacionvehiculo=localStorage.getItem('idcotizacionvehiculo');
		this.idagenda=localStorage.getItem('idagenda');
		this.userimageurl="background-image:url("+db.getServerHTTP()+JSON.parse(localStorage.getItem('user')).imageurl+")"  
		this.sucursal=JSON.parse(localStorage.getItem('user')).sucursal  
		this.fecha=localStorage.getItem('fechaagenda')  
		this.codusuario=JSON.parse(localStorage.getItem('user')).codusuario

	},

	mounted() {      

		let strSql;

		strSql="SELECT IN_KILOMETRAJEVEHICULO_COTIZACIONVEHICULO kilometraje,"
			+"DT_FECHAENTREGAOT_COTIZACIONVEHICULO fechaentregaot,"
			+"CONVERT(VARCHAR(10),DT_FECHAENTREGAOT_COTIZACIONVEHICULO,120) fechaentrega,"
			+"CONVERT(VARCHAR(10),DT_FECHAENTREGAOT_COTIZACIONVEHICULO,108) horaentrega,"
			+"COT.IN_ESORDENTRABAJOINTERNA_COTIZACIONVEHICULO datatipoot,"
			+"COT.IN_COD_TIPOTRABAJO datatipotrabajo,"
			+"CLI.ST_NOMBRE_CLIENTE nombre,"
			+"CLI.ST_APEPAT_CLIENTE paterno,"
			+"CLI.ST_APEMAT_CLIENTE materno,"
			+"CLI.ST_FONO1_CLIENTE fono1,"
			+"CLI.ST_FONO2_CLIENTE fono2,"
			+"'' fonowhatsapp,"
			+"CLI.ST_EMAIL_CLIENTE email,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL1_VEHICULO) marca,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL2_VEHICULO) modelo,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL3_VEHICULO) version,"
			+"IN_AGNOFABRICACION_VEHICULO agno,ST_PLACAPATENTE_VEHICULO placapatente,ST_NVIN_VEHICULO vin,"
			+"ST_IDEXTERNO_COTIZACIONVEHICULO idexterno"
			+" FROM T_VEH_COTIZACIONVEHICULO COT,T_VEH_VEHICULO V,T_CLI_CLIENTE CLI"
			+" WHERE COT.IN_COD_COTIZACIONVEHICULO="+this.idcotizacionvehiculo
			+" AND COT.IN_COD_VEHICULO=V.IN_COD_VEHICULO"
			+" AND COT.IN_COD_CLIENTE=CLI.IN_COD_CLIENTE"

		db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			this.OT=result.data.data

			this.OT.fono1=this.OT.fono1.replace(/-/g,'\n')
			//this.OT.fonowhatsapp="+"

			this.OT.fonowhatsapp=this.OT.fono1
			if(this.OT.fono1!=null && this.OT.fono1.substring(0,3)!="569")
				this.OT.fonowhatsapp=""+this.OT.fono1

		}}); 
/*
		axios(db.Query(strSql)).then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
				this.vehiculo=result.data.data;
		}});
		*/
		/*
		db.getDataForm(Formsubmit,this.params)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
console.log(result.data.data)
			//field_DT_FECHAENTREGAOT_COTIZACIONVEHICULO
			this.OT=result.data.data
		}}); 
		*/
	},



	methods: {

		guardar(){
			if(document.getElementById("fechaentrega").value=="" && document.getElementById("fechaentrega").value=="")
				document.getElementById("fechaentregaot").value=""
			else
				document.getElementById("fechaentregaot").value=document.getElementById("fechaentrega").value.replace("-","/") + " " +document.getElementById("horaentrega").value

			var strErr=validate.check(Formsubmit)
			if (strErr==""){
				validate.Cleannumericfield(Formsubmit);

				db.sendDataForm(Formsubmit,this.params)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
				}});
			}

		},
		enviarmail(){
			if(document.getElementById("fechaentrega").value=="" && document.getElementById("fechaentrega").value=="")
				document.getElementById("fechaentregaot").value=""
			else
				document.getElementById("fechaentregaot").value=document.getElementById("fechaentrega").value.replace("-","/") + " " +document.getElementById("horaentrega").value

			var strErr=validate.check(Formsubmit)
			if (strErr==""){
				validate.Cleannumericfield(Formsubmit);

				db.sendDataForm(Formsubmit,this.params)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
				strErr=validate.check(formemail)
				if (strErr==""){
					db.getFx("ot.observacion",'{"idcotizacionvehiculo":"'+ this.idcotizacionvehiculo+'","motivo":"Envío email cambio fecha entrega","obs":"'+ document.getElementById("txtemail").value +'","codasesor":"'+this.codusuario+'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
						db.getFx("ot.sendmail",'{"idcotizacionvehiculo":"'+ this.idcotizacionvehiculo+'","codasesor":"'+this.codusuario+'","idfileemail":"'+ this.idFile+'","emailcliente":"'+ document.getElementById("txtemail").value +'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
							window.location="/MisOT"
						}});
					}});

					}
					
				}});
			}


		},
		enviarwhatsapp(){
			if(document.getElementById("fechaentrega").value=="" && document.getElementById("fechaentrega").value=="")
				document.getElementById("fechaentregaot").value=""
			else
				document.getElementById("fechaentregaot").value=document.getElementById("fechaentrega").value.replace("-","/") + " " +document.getElementById("horaentrega").value

			var strErr=validate.check(Formsubmit)
			if (strErr==""){
				validate.Cleannumericfield(Formsubmit);

				db.sendDataForm(Formsubmit,this.params)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
				var strErr=validate.check(formwhatsapp)
				// Token (idexterno) por seguridad + URL de seguimiento desde config.json
				var strIDWhatsapp=db.getOtProcessUrl()+"?id="+this.OT.idexterno
				var txtTexto="📅 Cambió la fecha de entrega de tu OT. Revísala aquí: "+strIDWhatsapp

				if (strErr==""){
					db.getFx("ot.observacion",'{"idcotizacionvehiculo":"'+ this.idcotizacionvehiculo+'","motivo":"Envío whatsapp Orden trabajo","obs":"'+ document.getElementById("txtfonowhatsapp").value +'","codasesor":"'+this.codusuario+'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
						db.getFx("ot.sendwhatsapp",'{"idcotizacionvehiculo":"'+ this.idcotizacionvehiculo+'","codasesor":"'+this.codusuario+'","fono":"'+ document.getElementById("txtfonowhatsapp").value +'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
							window.open("https://api.whatsapp.com/send?phone="+document.getElementById("txtfonowhatsapp").value+"&text="+txtTexto, "_blank");
							window.location="/MisOT"
						}});
					}});

					}

				}});
			}

		},
	
	}


}

</script>
